import { useEffect, useState } from "react";
import { Plus, Trash2, Edit3, Check, X, GripVertical } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

const inputCls = "bg-ink-800 border border-ink-600 rounded-lg px-3 py-2 text-sm outline-none focus:border-brand transition-colors text-white";

export default function Categories() {
  const [cats, setCats] = useState([]);
  const [form, setForm] = useState({ name: "", slug: "", description: "", order: 0 });
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});

  const load = () => api.get("/admin/categories").then((r) => setCats(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.name.trim()) return;
    try { await api.post("/admin/categories", { ...form, order: cats.length + 1 }); toast.success("Category added"); setForm({ name: "", slug: "", description: "", order: 0 }); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const save = async (id) => { try { await api.put(`/admin/categories/${id}`, editForm); toast.success("Saved"); setEditId(null); load(); } catch (e) { toast.error(apiErr(e)); } };
  const del = async (id) => { if (!window.confirm("Delete this category?")) return; try { await api.delete(`/admin/categories/${id}`); load(); } catch (e) { toast.error(apiErr(e)); } };

  return (
    <div className="max-w-3xl">
      <div className="mb-6"><div className="label-mono mb-1">Taxonomy</div><h1 className="font-display font-extrabold text-white text-3xl">Categories</h1><p className="text-slate-400 text-sm mt-1">These drive the public navigation and homepage sections.</p></div>

      <div className="rounded-xl border border-ink-600 bg-ink-900 p-5 mb-6">
        <div className="grid sm:grid-cols-3 gap-3">
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="category-name" className={inputCls} placeholder="Category name" />
          <input value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} className={inputCls} placeholder="slug (optional)" />
          <button onClick={create} data-testid="category-add" className="inline-flex items-center justify-center gap-1.5 bg-brand text-brand-dark font-bold text-sm px-4 py-2 rounded-lg hover:bg-brand-neon transition-colors"><Plus size={15} /> Add</button>
        </div>
        <input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className={`${inputCls} w-full mt-3`} placeholder="Short description (shown on category page)" />
      </div>

      <div className="rounded-xl border border-ink-600 bg-ink-900 divide-y divide-ink-700" data-testid="category-list">
        {cats.map((c) => (
          <div key={c.id} className="flex items-center gap-3 p-4">
            <GripVertical size={16} className="text-ink-600" />
            {editId === c.id ? (
              <>
                <input value={editForm.name} onChange={(e) => setEditForm({ ...editForm, name: e.target.value })} className={`${inputCls} flex-1`} />
                <input value={editForm.description} onChange={(e) => setEditForm({ ...editForm, description: e.target.value })} className={`${inputCls} flex-1`} placeholder="Description" />
                <button onClick={() => save(c.id)} className="p-2 text-brand"><Check size={16} /></button>
                <button onClick={() => setEditId(null)} className="p-2 text-slate-500"><X size={16} /></button>
              </>
            ) : (
              <>
                <div className="flex-1"><div className="text-white font-semibold">{c.name}</div><div className="text-xs text-slate-500 font-mono-label">/{c.slug}</div></div>
                <div className="text-sm text-slate-400 flex-1 truncate hidden sm:block">{c.description}</div>
                <button onClick={() => { setEditId(c.id); setEditForm({ name: c.name, slug: c.slug, description: c.description, order: c.order }); }} className="p-2 text-slate-400 hover:text-brand"><Edit3 size={15} /></button>
                <button onClick={() => del(c.id)} className="p-2 text-slate-400 hover:text-red-400"><Trash2 size={15} /></button>
              </>
            )}
          </div>
        ))}
        {cats.length === 0 && <div className="p-8 text-center text-slate-500 text-sm">No categories yet.</div>}
      </div>
    </div>
  );
}
